import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import { FormFieldTypes } from '@App/enum/form-field-types'
import {
    getHoldText,
    getHoldTypeIdFromName,
    WORK_HOLD_STATUS,
    WorkHoldStatusNames,
} from '@App/helpers/work-entities/utils/is-hold-status'

export interface RightsholderCatalogSearchFilter {
    workHoldStatusFilter?: WorkHoldStatusFilterType[]
    matchedRecordingsFilter?: MatchedRecordingsFilterType[]
}

export type WorkHoldStatusFilterType = Record<'MLC_OVERCLAIM' | 'MLC_DISPUTE', boolean>
export type MatchedRecordingsFilterType = Record<
    'all_works' | 'has_matched_recordings' | 'has_no_matched_recordings',
    boolean
>

export const catalogFilterTransformers: Partial<
    Record<keyof RightsholderCatalogSearchFilter, (value: unknown) => Record<string, unknown>>
> = {
    workHoldStatusFilter: (value) => ({
        holdTypeId: (value as WorkHoldStatusNames[]).flatMap((name) => getHoldTypeIdFromName(name) ?? []),
    }),
}

export const catalogHoldFilterGroup: FilterFieldGroup<RightsholderCatalogSearchFilter> = {
    name: 'Hold Filters',
    allowMultiple: true,
    filterFields: [
        {
            workHoldStatusFilterType: {
                name: 'workHoldStatusFilter',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'MLC_OVERCLAIM',
                        label: '',
                        children: getHoldText(WORK_HOLD_STATUS.MLC_OVERCLAIM),
                    },
                    {
                        id: 'MLC_DISPUTE',
                        label: '',
                        children: getHoldText(WORK_HOLD_STATUS.MLC_DISPUTE),
                    },
                ],
            },
        },
    ],
}

export const catalogMatchedRecordingFilterGroup: FilterFieldGroup<RightsholderCatalogSearchFilter> = {
    name: 'Matched Recordings Filter',
    allowMultiple: false,
    filterFields: [
        {
            matchedRecordingsFilterType: {
                name: 'matchedRecordingsFilter',
                label: '',
                type: FormFieldTypes.RADIO,
                options: [
                    {
                        name: '',
                        label: 'Show all works',
                        default: true,
                    },
                    {
                        name: 'has_matched_recordings',
                        label: 'Only works with matched recordings',
                    },
                    {
                        name: 'has_no_matched_recordings',
                        label: 'Only works with no matched recordings',
                    },
                ],
            },
        },
    ],
}

export const RightsholderCatalogFilterCollection: Array<FilterFieldGroup<RightsholderCatalogSearchFilter>> = [
    catalogHoldFilterGroup,
    catalogMatchedRecordingFilterGroup,
]
